import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';
import axios from 'axios';
export default function AddGallery(props) {
    //const [items, setitems] = useState({ gal_unitid: "", gal_name: "", gal_url: [], gal_status:"1"})

    const [addunit, setunit] = useState([])
    const [gal_unitid, setgal_unitid] = useState("")
    const [files, setfiles] = useState([])
    const [mainimage, setmainimage] = useState([])
    const [items, setitems] = useState('Assets/images/image-placeholder.jpg')
    let url = "";
    useEffect(() => {
        fetchUnitdata();
    }, [fetchUnitdata])

    const GetMainImage = (e) => {
        url = process.env.REACT_APP_APIURL + "booking/GetMainImage?companyid=" + props.companyid + "&unitid=" + e.value;
        populatedata();
    }
    async function populatedata() {
        let data = await axios.get(url);
        //await fetch(url).then(res => res.json()).then((result) => {
            setitems(data.data)
        //});
    }
    const fileSelectHandler = (e) => {
        setfiles({ files: e.target.files });
    }
    const MainImageSelectHandler = (e) => {
        setmainimage({ files: e.target.files });
    }
    async function fetchUnitdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }

    const deleteimage = async (id) => {
        let result =false;
        let a = process.env.REACT_APP_APIURL + "booking/DeleteMainImage?mig_id="+ id;
        var data = await axios.get(a);
        if (data.status === 200) {
            result = true;
        }
        return result;
    }
        
   


        ///
        async function uploadMainImage() {

            const formData = new FormData();
            await formData.append("MainimageUrl", mainimage.files[0])
            await formData.append("UnitId", gal_unitid.value);

            try {
                const res = await axios.post(process.env.REACT_APP_APIURL + "booking/uploadMainfile", formData,
                    {
                        headers: {
                            'content-type': 'form-data'
                        }
                    })
                if (res.status === 201) {

                    return 1;
                }
                else if (res.status === 200) {
                    return 2
                }
            }
            catch (ex) {
                console.log(ex)
                return 0;
            }

        }
    ////
    async function uploadfile() {
        const formData = new FormData();
        for (let i = 0; i < files.files.length; i++) {
            await formData.append("gal_url", files.files[i])
        }
        await formData.append("gal_unitid", gal_unitid.value);
        await formData.append("company_id", props.companyid);
        //await formData.append("gal_name", "2");
        //await formData.append("gal_status", "1"); 
        try {
            const res = await axios.post(process.env.REACT_APP_APIURL + "booking/uploadGallery", formData,
                {
                    headers: {
                        'content-type': 'form-data'
                    }
                })
            if (res.status === 201) {
                return true;


            }
        }
        catch (ex) {

            console.log(ex)
            return false;
        }

    }

    const HandleSubmit = async () => {
        if (gal_unitid === "") {
            swal({
                icon: "error",
                title: "Unit is Required!"
            })
            return;
        }
        let f2 = document.getElementById("fileInputId").value
        let f1 =document.getElementById("fileInputId1").value
        if (f1 === "" && f2=== "" ) {
            swal({
                icon: "error",
                title: "Please select image!"
            })
            return;
        }
        if (f1 === "" && f2 !== "" ) {
            if (await uploadfile()) {
                setgal_unitid("");
                setitems({ images: 'Assets/images/image-placeholder.jpg' });
                document.getElementById("fileInputId").value = null;
                document.getElementById("fileInputId1").value = null;
                swal({
                    icon: "success",
                    title: "Saved Successfully"
                })
            }
            else {
                swal({
                    title: ":(",
                    text: "Data Saved Failed"
                })
            }
        }
        else if (f1 !== "" && f2 !== "") {

            let result = await deleteimage(gal_unitid.value);
            if (result) {
                if (await uploadMainImage() === 1) {
                    if (await uploadfile()) {
                        setgal_unitid("");
                        setitems({images: 'Assets/images/image-placeholder.jpg'});
                        document.getElementById("fileInputId").value = null;
                        document.getElementById("fileInputId1").value = null;
                        swal({
                            icon: "success",
                            title: "Saved Successfully"
                        })
                    }
                }
                else {
                    swal({
                        title: ":(",
                        text: "Data Saved Failed"
                    })
                }
            }
            else if (result === 2) {
                swal({
                    title: ":(",
                    text: ""

                })
            }
        }
        else if (f2 === "" || f1 !=="") {
            let result = await deleteimage(gal_unitid.value);
            if (result) {
                if (await uploadMainImage() === 1) {
                    swal({
                        icon: "success",
                        title: "Saved Successfully"
                    });
                    setgal_unitid("");
                    setitems({images: 'Assets/images/image-placeholder.jpg' });
                    document.getElementById("fileInputId").value = null;
                    document.getElementById("fileInputId1").value = null;
                }
            }
        }
    }
    return (
        <div className="row">
            <div className="col-12 col-lg-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">Add Gallery</h4>
                    </div>
                    <div className="card-body">
                        <form encType="" >
                            <div className="row form-material">
                                <div className="mb-3 col-12">
                                    <label htmlFor="unit_name" className="form-label">Unit</label>
                                    <Select name="unit" autoComplete="off" value={gal_unitid} options={addunit} onChange={(e) => { setgal_unitid(e); GetMainImage(e) }} />
                                </div>
                                <div className="mb-3 col-12">
                                    <label htmlFor="unit_name" className="form-label">Main Image</label>
                                    <input className="form-control" id="fileInputId1" type="file" onChange={MainImageSelectHandler} accept="image/*" />
                                </div>
                                <div className="mb-3 col-12">
                                    <img src={items.image!==undefined ? 'data:image/png;base64,' + items.image:"Assets/images/image-placeholder.jpg"} width="250px" />
                                </div>
                                
                                <div className="mb-3 col-12">
                                    <label htmlFor="unit_name" className="form-label">Gallery</label>
                                    <input className="form-control" multiple id="fileInputId" type="file" onChange={fileSelectHandler} accept="image/*" />
                                </div>
                            </div>
                            <button type="button" onClick={HandleSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}